import { getApiBaseUrl } from "@/config/api";

export class CallbackRequestError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "CallbackRequestError";
    this.status = status;
  }
}

export async function submitCallbackRequest({
  name,
  phone,
  source,
  honeypot = "",
}) {
  const baseUrl = getApiBaseUrl();
  if (!baseUrl) {
    throw new CallbackRequestError(
      "Callback service is not configured yet. Please try again later.",
      0,
    );
  }

  const response = await fetch(`${baseUrl}/api/callback`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      name: name.trim(),
      phone,
      source,
      company_website: honeypot,
    }),
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (response.status === 429) {
    throw new CallbackRequestError(
      "Too many requests. Please wait a while before trying again.",
      429,
    );
  }

  if (!response.ok) {
    throw new CallbackRequestError(
      "Unable to submit your request. Please check your details and try again.",
      response.status,
    );
  }

  return payload;
}
